import { useLazyUsersListQuery, userApi } from '../../../api/user-management-api';
import { useDispatch } from 'react-redux';
import { UsersListManagemntDataRequest, UsersListManagemntDataResponse } from '../../../api/user-management-types';
import { useSharedQueryTriggerStatus } from '@shared/lib/hooks/use-shared-query-trigger-status/use-shared-query-trigger-status';

/* 
    Позволяет шарить результат useLazyQuery между разными компонентами, использующими useSharedQuery
    При обновлении  результата useLazyQuery происходит обновление всех зависимых компонентов
*/
export const useUsersListSharedQuery = (parameters: UsersListManagemntDataRequest) => {
    const dispatch = useDispatch();
    const { setTriggerStatus } = useSharedQueryTriggerStatus();
    const [queryTrigger] = useLazyUsersListQuery();
    const queryResult = userApi.endpoints.usersList.useQueryState(parameters);

    const resetState = () => {
        dispatch(userApi.util.invalidateTags(['UsersList']));
    };

    const updateQueryData = (data: Partial<UsersListManagemntDataResponse>) => {
        dispatch(
            // @ts-expect-error
            userApi.util.updateQueryData('usersList', parameters, (draft) => {
                Object.assign(draft, data);
            })
        );
    };

    const handleTrigger = async (args: UsersListManagemntDataRequest) => {
        setTriggerStatus('pending');
        const result = await queryTrigger(args, true);
        setTriggerStatus('completed');
        return result;
    };

    return [handleTrigger, queryResult, resetState, updateQueryData] as const;
};
